import React from "react";
import priceFormatter from "../../helpers/PriceFormater";

const CATEGORY_LABELS = [
  ["Users", "Users"],
  ["Licenses", "Licenses"],
  ["AddOnServices", "Add-on services"],
  ["Domains", "Domains"],
  ["PostAdjustments", "Post adjustments"],
];

// Totals come from the API summary; this card only formats them.
const BillingSummaryCard = ({ summary, total, isQuarterly, indexAdjustments = [] }) => {
  const totalsByCategory = Object.fromEntries(
    (summary?.categoryTotals || []).map((t) => [t.category, t])
  );
  const indexFactors = [
    ...new Set(
      indexAdjustments.map((i) => Number(i.indexFactor)).filter((f) => f && f !== 1)
    ),
  ];

  return (
    <div className="border rounded-md shadow-md p-4 mb-4">
      <h2 className="mb-2">Summary</h2>
      <table className="w-full text-sm text-left">
        <thead>
          <tr className="border-b text-gray-600">
            <th className="py-2 px-3">Category</th>
            <th className="py-2 px-3">Per month</th>
            {isQuarterly && <th className="py-2 px-3">Per quarter</th>}
          </tr>
        </thead>
        <tbody>
          {CATEGORY_LABELS.map(([category, label]) => {
            const row = totalsByCategory[category];
            const monthly = isQuarterly ? row?.monthlyTotal : row?.periodTotal;
            return (
              <tr key={category} className="border-b">
                <td className="py-2 px-3">{label}</td>
                <td className="py-2 px-3">
                  {monthly === null || monthly === undefined ? "—" : priceFormatter(monthly)}
                </td>
                {isQuarterly && (
                  <td className="py-2 px-3">{priceFormatter(row?.periodTotal)}</td>
                )}
              </tr>
            );
          })}
          <tr className="font-bold">
            <td className="py-2 px-3">Invoice total</td>
            {isQuarterly && <td className="py-2 px-3"></td>}
            <td className="py-2 px-3">{priceFormatter(total)}</td>
          </tr>
        </tbody>
      </table>
      {indexFactors.length > 0 && (
        <p className="text-sm text-gray-600 mt-2">
          Index adjustment {indexFactors.map((f) => `×${f}`).join(", ")} applied to the
          invoice total
        </p>
      )}
    </div>
  );
};

export default BillingSummaryCard;
